import React from 'react';
import { FaBars } from 'react-icons/fa';
import { BsCoin } from 'react-icons/bs';
import { Icons } from '@/utils/Icons';
import { NavLink } from 'react-router-dom';
import { useUserInfo } from '@/hooks/useUserInfo';

export default function MobileNavbar({ menuOpen, active, setActive, onMenuClick }: any) {
  const { username } = useUserInfo();

  const items = [
    { label: 'In-Play', icon: Icons.Inplay, path: '/sport/inplay-events' },
    { label: 'Sports', icon: Icons.Cricket, path: '/sport' },
    { label: 'Menu', icon: menuOpen ? Icons.Cross : FaBars, path: '' },
    { label: 'Casino', icon: BsCoin, path: '/casino' },
    {
      label: username ? username : 'Register',
      icon: Icons.User,
      path: username ? '/user' : '?mode=register',
    },
  ];
  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-[7000]">
      {/* ✅ SVG CLIP PATH */}
      <svg width="0" height="0" className="absolute">
        <defs>
          <clipPath id="menu" clipPathUnits="objectBoundingBox">
            <path d="M0,1 C0.15,1 0.25,0 0.5,0 C0.75,0 0.85,1 1,1 L1,1 L0,1 Z" />
          </clipPath>
        </defs>
      </svg>

      {/* 🔥 CURVE (FIXED SIZE + CENTERED) */}
      <div
        className="absolute bottom-[70px] w-[20%] flex justify-center transition-all duration-300"
        style={{ transform: `translateX(${active * 100}%)` }}
      >
        <div
          className="w-[112px] h-[24px]"
          style={{
            backgroundColor: '#323738',
            clipPath: 'url(#menu)',
          }}
        />
      </div>

      {/* 🔥 NAVBAR */}
      <div className="h-[70px] bg-[#323738] flex relative">
        {items.map((item, index) => {
          const Icon = item.icon;
          const isActive = index === active;

          if (index === 2) {
            return (
              <button
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  setActive(index);
                  onMenuClick();
                }}
                className="flex-1 flex flex-col items-center justify-center text-xs relative"
              >
                <Icon
                  className={`text-[22px] transition-all duration-200 ${
                    menuOpen ? 'text-[#FFC600]' : 'text-gray-400'
                  }`}
                />
                <span className={`mt-1 ${menuOpen ? 'text-[#FFC600]' : 'text-gray-400'}`}>
                  {item.label}
                </span>
              </button>
            );
          }
          return (
            <NavLink
              to={item.path}
              key={index}
              onClick={() => {
                setActive(index);
                if (menuOpen) onMenuClick();
              }}
              className="flex-1 flex flex-col items-center justify-center text-xs relative"
            >
              <Icon className={`text-[22px] ${isActive ? 'text-[#FFC600]' : 'text-gray-400'}`} />
              <span className={`mt-1 ${isActive ? 'text-[#FFC600]' : 'text-gray-400'}`}>
                {item.label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
}
